if (!customElements.get('up-insta-story-dialog')) {
  customElements.define(
    'up-insta-story-dialog',
    class upInstaStoryDialog extends HTMLElement {
      constructor() {
        super();

        // Sevarals options to close the modal
        if (this.querySelector('[aria-controls^="ModalClose"]')) {
          this.querySelector('[aria-controls^="ModalClose"]').addEventListener('click', this.hide.bind(this, false));
        }
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') this.hide();
        });

        this.addEventListener('click', (event) => {
          if (event.target === this) this.hide();
        });

        this.video = this.querySelector('video');

        // Player button
        this.buttonVolume = this.querySelector('[aria-controls^="VideoVolume"]');
        this.buttonVolume.addEventListener('click', this.toggleVolumeState.bind(this));

        this.buttonPlay = this.querySelector('[aria-controls^="VideoPlay"]');
        this.buttonPlay.addEventListener('click', this.togglePlayerState.bind(this));

        // Segments UI
        this.segments = Array.from(this.querySelectorAll('.up-insta-player__segment'));
        this.segments.forEach((segment) => {
          segment.addEventListener('click', this.onSegmentClick.bind(this));
        });
        this.currentSegment = this.segments[0];

        // Prev / Next player button
        this.buttonPlayerPrev = this.querySelector('.up-insta-navigation__button--chapter');
        this.buttonPlayerNext = this.querySelector(
          '.up-insta-navigation__button--chapter.up-insta-navigation__button--next'
        );

        this.buttonPlayerPrev.addEventListener('click', () => this.onButtonPlayerClick.bind(this)(true));
        this.buttonPlayerNext.addEventListener('click', () => this.onButtonPlayerClick.bind(this)(false));

        // Prev / Next stories button
        this.buttonStoryPrev = this.querySelector(
          '.up-insta-navigation__button.up-insta-navigation__button--prev:not(.up-insta-navigation__button--chapter)'
        );
        this.buttonStoryNext = this.querySelector(
          '.up-insta-navigation--next .up-insta-navigation__button.up-insta-navigation__button--next:not(.up-insta-navigation__button--chapter)'
        );

        this.buttonStoryPrev.addEventListener('click', () => this.goToOtherStory.bind(this)(true));
        this.buttonStoryNext.addEventListener('click', () => this.goToOtherStory.bind(this)(false));

        // Spinner
        this.loadingSpinner = this.querySelector('.up-insta-popup-modal__content > .loading-overlay');

        // Swipe Data
        this.timerPauseOnTouch = null;
        this.pauseOnTouchEnabled = false;

        // For Mobile Safari
      }

      connectedCallback() {
        if (this.moved) return;
        this.moved = true;
        document.body.appendChild(this);
        this.resizeStory();

        this.video.addEventListener('waiting', this.onVideoWaiting.bind(this));
        this.video.addEventListener('playing', this.onVideoPlaying.bind(this));

        this.video.addEventListener('timeupdate', this.onVideoUpdate.bind(this));
        this.video.addEventListener('ended', this.onVideoEnded.bind(this));
        this.video.addEventListener('play', this.onVideoPlay.bind(this));
        this.video.addEventListener('click', this.onVideoClick.bind(this));
        this.video.addEventListener('contextmenu', this.onVideoRightClick.bind(this));

        // Touch Events on mobile
        this.video.addEventListener('touchstart', this.onVideoTouchStart.bind(this), { passive: false });
        this.video.addEventListener('touchmove', this.onVideoTouchMove.bind(this), { passive: false });
        this.video.addEventListener('touchend', this.onVideoTouchEnd.bind(this), { passive: false });

        // this.video.addEventListener('click', () => this.onButtonPlayerClick.bind(this)(false));

        window.addEventListener('resize', this.resizeStory.bind(this));
      }

      show(opener) {
        this.openedBy = opener;
        const popup = this.querySelector('.template-popup');
        document.body.classList.add('overflow-hidden');
        this.setAttribute('open', '');
        if (popup) popup.loadContent();
        trapFocus(this, this.querySelector('[role="dialog"]'));
        window.pauseAllMedia();

        // From the slider
        if (this.openedBy.nodeName === 'UP-INSTA-STORY-OPENER') {
          if (this.dataset.autoplay === 'true') this.togglePlayerState(null, true);
          if (this.dataset.automute === 'false') this.toggleVolumeState(null, true);
        }

        // From the modal story to the next/prev one
        if (this.openedBy.nodeName === 'UP-INSTA-STORY-DIALOG') {
          if (this.video.paused) this.togglePlayerState();
          if (this.video.muted != this.openedBy.video.muted) this.toggleVolumeState(null, !this.openedBy.video.muted);
        }
      }

      hide() {
        document.body.classList.remove('overflow-hidden');
        document.body.dispatchEvent(new CustomEvent('modalClosed'));
        this.removeAttribute('open');
        removeTrapFocus(this.openedBy);
        if (!this.video.paused) this.togglePlayerState();
        this.resetSegments();
      }

      resetSegments() {
        this.segments.forEach((segment) => {
          segment.removeAttribute('open');
          segment.style.setProperty('--up-insta-player-segment-progress', 0);
        });

        this.currentSegment = this.segments[0];
        this.currentSegment.setAttribute('open', '');
        this.video.currentTime = 0;
      }

      resizeStory() {
        const sizeFactor = window.innerWidth > 989 ? 0.85 : 1,
          ratioWidth = (window.innerWidth / 375) * sizeFactor,
          ratioHeight = (window.innerHeight / 667) * sizeFactor;

        requestAnimationFrame(() => {
          this.style.setProperty('--calc-font-size-ratio', `${Math.min(ratioWidth, ratioHeight) * 10}px`);
        });
      }

      togglePlayerState(event, forcePlay = false) {
        if (this.video.paused || forcePlay) {
          this.buttonPlay.classList.remove('up-insta-player--paused');
          this.video.play();
        } else {
          // Fix if video still not loaded
          if (!(this.video.currentTime > 0 && this.video.readyState > this.video.HAVE_CURRENT_DATA)) return;
          this.buttonPlay.classList.add('up-insta-player--paused');
          this.video.pause();
        }
      }

      toggleVolumeState(event, forceSound = false) {
        if (this.video.muted || forceSound) {
          this.buttonVolume.classList.remove('up-insta-player--sound');
          this.video.muted = false;
        } else {
          this.buttonVolume.classList.add('up-insta-player--sound');
          this.video.muted = true;
        }
      }

      onSegmentClick(event) {
        this.currentSegment = event.target;

        // Remove open on all segment + fill
        this.segments.forEach((segment) => {
          segment.removeAttribute('open');
          if (parseFloat(segment.dataset.timecodeStart) < parseFloat(this.currentSegment.dataset.timecodeStart)) {
            segment.style.setProperty('--up-insta-player-segment-progress', 1);
          } else {
            segment.style.setProperty('--up-insta-player-segment-progress', 0);
          }
        });

        this.currentSegment.setAttribute('open', '');
        this.video.currentTime = parseFloat(this.currentSegment.dataset.timecodeStart);
      }

      onButtonPlayerClick(isPrev) {
        const currentSegmentIndex = this.segments.findIndex((segment) => segment === this.currentSegment);
        if (currentSegmentIndex < 0) return;

        let newSegmentIndex = isPrev ? currentSegmentIndex - 1 : currentSegmentIndex + 1;
        if (newSegmentIndex < 0) {
          this.goToOtherStory(true);
          return;
        }
        if (newSegmentIndex >= this.segments.length) {
          this.goToOtherStory(false);
          return;
        }

        this.onSegmentClick({ target: this.segments[newSegmentIndex] });
      }

      onVideoClick(event) {
        this.onButtonPlayerClick(event.clientX < window.innerWidth / 2);
      }

      onVideoRightClick(event) {
        event.preventDefault();
        return false; // Disable the right click option
      }

      onVideoEnded() {
        this.buttonPlay.classList.add('up-insta-player--paused');
        this.resetSegmentsOnPlay = true;
        this.goToOtherStory(false);
      }

      onVideoPlay() {
        if (this.resetSegmentsOnPlay) {
          this.resetSegmentsOnPlay = false;
          this.resetSegments();
        }
      }

      onVideoWaiting(event) {
        console.log('on waiting');
        this.loadingSpinner.classList.remove('hidden');
      }

      onVideoPlaying(event) {
        console.log('playing');
        this.loadingSpinner.classList.add('hidden');
      }

      onVideoUpdate() {
        const currentTimecodeStart = parseFloat(this.currentSegment.dataset.timecodeStart);
        const currentTimecodeEnd = parseFloat(this.currentSegment.dataset.timecodeEnd);

        if (this.video.currentTime >= currentTimecodeStart && this.video.currentTime <= currentTimecodeEnd) {
          if (!this.video.paused) {
            this.currentSegment.style.setProperty(
              '--up-insta-player-segment-progress',
              Math.min((this.video.currentTime - currentTimecodeStart) / (currentTimecodeEnd - currentTimecodeStart), 1)
            );
          }
        } else {
          this.currentSegment.style.setProperty('--up-insta-player-segment-progress', 1);
          this.currentSegment.removeAttribute('open');

          // Get the new current segment
          this.currentSegment =
            this.segments.find(
              (segment) =>
                this.video.currentTime >= segment.dataset.timecodeStart &&
                this.video.currentTime <= segment.dataset.timecodeEnd
            ) || this.currentSegment;
          this.currentSegment.setAttribute('open', '');
        }
      }

      goToOtherStory(isPrev) {
        // Story
        if (!this.currentStoryIndex || !this.stories) {
          this.stories = Array.from(
            document.querySelectorAll(`up-insta-story-dialog[data-section-id='${this.dataset.sectionId}']`)
          );
          this.currentStoryIndex = this.stories.findIndex((story) => story.id === this.id);
        }

        const newStoryIndex = isPrev ? this.currentStoryIndex - 1 : this.currentStoryIndex + 1;

        if (newStoryIndex < 0 || newStoryIndex >= this.stories.length) {
          // No more stories
          this.hide();
          return;
        }

        this.hide();
        this.stories[newStoryIndex].show(this);
      }

      // Swipe events
      onVideoTouchStart(event) {
        // For Mobile Safari

        // Pour Play/Pause on hold
        this.timerPauseOnTouch = setTimeout(() => {
          this.pauseOnTouchEnabled = true;
          if (!this.video.paused) this.togglePlayerState();
        }, 500);
      }

      onVideoTouchMove(event) {
        // TODO : annuler uniquement s'il y a minimum de delta dans le move
        // if (!this.video.paused) this.togglePlayerState(); // Pause dès qu'on bouge
        // if (this.timerPauseOnTouch) clearTimeout(this.timerPauseOnTouch);
        //console.log(event);
      }

      onVideoTouchEnd(event) {
        event.preventDefault();
        // console.log(event);

        // Pour Play/Pause on hold
        if (this.timerPauseOnTouch) clearTimeout(this.timerPauseOnTouch);
        if (this.pauseOnTouchEnabled) {
          this.pauseOnTouchEnabled = false;
          if (this.video.paused) this.togglePlayerState(); // Remet en play
        }
      }
    }
  );
}

if (!customElements.get('up-insta-story-opener')) {
  customElements.define(
    'up-insta-story-opener',
    class upInstaStoryOpener extends HTMLElement {
      constructor() {
        super();

        this.addEventListener('click', () => {
          const modal = document.querySelector(this.getAttribute('data-modal'));
          if (modal) modal.show(this);
        });
      }
    }
  );
}
